import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { get, cloneDeep } from 'lodash';
export default {
  name: 'CoreDeviceTemplateKeyValueEditor',
  props: {
    deviceMeta: {
      type: Object,
      required: true
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])),
  watch: {
    deviceMeta: function deviceMeta() {
      this.initialMetaDataSetup();
    }
  },
  methods: {
    get: get,
    initialMetaDataSetup: function initialMetaDataSetup() {
      if (!this.deviceMeta.customProperties) {
        this.deviceMeta.customProperties = {
          '': {
            defaultValue: '',
            requiredValue: true
          }
        };
      }
    },
    keyValueKeyChanged: function keyValueKeyChanged(prior, newKey) {
      var baseKey = newKey;
      var uniqueKey = newKey;
      var i = 0;

      while (this.deviceMeta.customProperties[uniqueKey] !== undefined) {
        i++;
        uniqueKey = "".concat(baseKey).concat(i);
      }

      this.deviceMeta.customProperties[uniqueKey] = this.deviceMeta.customProperties[prior];
      delete this.deviceMeta.customProperties[prior];
      this.deviceMeta.customProperties = cloneDeep(this.deviceMeta.customProperties);
    },
    addKeyValuePair: function addKeyValuePair() {
      if (this.deviceMeta.customProperties[''] === undefined) {
        this.deviceMeta.customProperties[''] = {
          defaultValue: '',
          requiredValue: true
        };
      }

      this.deviceMeta.customProperties = cloneDeep(this.deviceMeta.customProperties);
    },
    removeKeyValuePair: function removeKeyValuePair(key) {
      delete this.deviceMeta.customProperties[key];
      this.deviceMeta.customProperties = cloneDeep(this.deviceMeta.customProperties);
    }
  }
};